module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-Pathfinder-Playful.0552e555.jpeg";